import { getEnvironment } from "@grafit/shared/utils/envs.front";
import { Ribbon } from "../molecules/ribbon";

export const EnvironmentRibbon = () => {
  const environment = getEnvironment();

  if (environment === "production") {
    return null;
  }

  const label = `${environment} env`;

  return <Ribbon label={label} />;
};
